import React from "react";
var __jsx = React.createElement;
import { Fragment } from "react";
import { LandingPageComponentType } from "@type/models/cms-landing";
import carsPrices__renderHeadlessComponent from "@/pages/car-prices/carsPrices__renderHeadlessComponent";
var validComponents = [LandingPageComponentType.LAYOUT_BREADCRUMB, LandingPageComponentType.LP_CAR_PRICES_HERO, LandingPageComponentType.LP_CAR_PRICES_CAR_PRICES_DETAILS_TABLE, LandingPageComponentType.BROWSE_CARS_BY, LandingPageComponentType.LP_COMPONENTS_BROWSER_CARS_BY_PRICE_RANGE, LandingPageComponentType.LP_CAR_PRICES_BROWSER_PRICES_MK_MDL_YR];

//const CarsPricesLanding: FC<IFinancing PageResponse> = (
var CarsPricesMakesModels = function CarsPricesMakesModels(carsPageResponse) {
  return carsPageResponse.carsPricesPage.contentSections.filter(function (section) {
    return validComponents.includes(section.__component);
  }).map(function (landingSection, index) {
    return /*#__PURE__*/React.createElement(Fragment, {
      key: index
    }, carsPrices__renderHeadlessComponent(carsPageResponse, landingSection));
  });
};
export default CarsPricesMakesModels;